<template>
  <v-app>
 

  <!-- Sizes your content based upon application components -->
  <v-main  style="background-color:#F3F3F4" >
                   
      
        <v-container  fill-height >

          <!-- <v-card outlined style="background-color:#F3F3F4" > -->
           <v-container   >
             <form role="form" @submit.prevent="logar" >
              <v-row>



                <v-col              
                 
                  align="center"
                  justify="center"
                     
                >
                 <v-card
                    class="mx-auto"
                    max-width="500"
                    outlined
                     elevation="10"
                     rounded="md"
                  >
                 <br/>
                 <br/>


                        <v-row>
                          <v-col              
                          cols="12"
                          md="12"
                          align="center"
                          justify="center"
                        >
                          <v-img                
                            max-height="100"
                            max-width="150"
                            width="150"
                          src="logo3mm.png"
                          ></v-img>
                        </v-col>
                      </v-row>


                      <v-row  align="center"
                          justify="center">
                      
                        <v-col              
                          :cols="colunas"
                          :md="colunas"   
                          align="center"
                          justify="center"
                          class="primary--text"
                        >
                        <h2> {{nameApp}} </h2>
                        </v-col>
                      </v-row>

                      <v-row  align="center"
                          justify="center">
                      
                        <v-col              
                          :cols="colunas"
                          :md="colunas"              
                        >
                          <v-text-field
                              ref="email"
                              label="Usuário"
                              placeholder="Email"
                              name="email" 
                              @change="$v.email.$touch()"
                              @input="setErrorLogin"
                              v-model="email"

                            ></v-text-field>
                        </v-col>
                      </v-row>

                      <v-row  align="center"
                          justify="center">
                      
                        <v-col              
                          :cols="colunas"
                          :md="colunas"              
                        >
                          <v-text-field
                              label="Senha"
                              placeholder="Senha"
                              name="password" 
                              type="password" 
                              @change="$v.password.$touch()"
                              @input="setErrorLogin"
                              v-model="password"
                            ></v-text-field>
                        </v-col>
                      </v-row>


                      <v-row  align="center"
                          justify="center">        

                        <v-col              
                          :cols="colunas"
                          :md="colunas"
                          >
                          <p v-if="errorLogin" class="failedLogin">Usuário ou Senha Inválidos</p>
                          <v-btn color="primary" width="100%" :disabled="$v.$invalid || $v.$error" type="submit" >    
                              Entrar       
                            </v-btn>
                        </v-col>
                      </v-row>

                      <v-row  align="center"
                          justify="center">
                      
                        <v-col
                          :md="colunas"   
                          align="center"
                          justify="center"  
                          class="text-caption"  
                          @click="$router.push({ name: 'reqChangePassword'})"     
                          style="cursor:pointer"  
                        >
                        Recuperar Senha
                        </v-col>
                        </v-row>


                        <v-row  align="center"
                          justify="center">
                      
                        <v-col                                
                          :md="colunas" 
                          align="center"
                          justify="center"  
                          class="text-caption"         
                        >
                        {{nameApp}} - {{companyDeveloper}} © {{ano}}
                        </v-col>
                        
                      </v-row>
                  <!-- </v-card> -->

                    </v-card>
                  </v-col>
                </v-row>
             </form>
           </v-container>
        </v-container>
      
  
  </v-main>

  <!-- <v-footer app>
    <! -- -- >
  </v-footer> -->
</v-app>
</template>


<script>

//import {required,email,numeric,minValue,minLength,sameAs,requiredUnless} from 'vuelidate/lib/validators';
import {required} from 'vuelidate/lib/validators';
import axios from 'axios';
//import {mapActions} from 'vuex';

export default{
    data(){
        return {
            email:'',
            password:'',
            colunas: '11'
        }
    },
    computed:{
        errorLogin(){
            return this.$store.getters['app/getErrorLogin'];
        },
        nameApp(){
          return this.$store.getters['app/nameApp'];
        },
        companyDeveloper(){
          return this.$store.getters['app/companyDeveloper'];
        },
        ano(){          
          var d = new Date();
          return d.getFullYear(); 
        }    
    },
    methods:{
        setErrorLogin(){
            this.$store.commit('app/setErrorLogin',false);
        },
        logar(){
            // console.log(this.email);
            this.$store.dispatch('app/login',{
                 email: this.email,
                 password: this.password
            });
        }
    },
    created(){
      if(this.$route.query.activate && this.$route.query.activate!=''){
        axios.get('/auth/activate/' + this.$route.query.activate)
          .then(res =>{
            if(res.data && res.data.success){
              if(res.data.message){
                this.$toastr('success', res.data.message);
              }else{
                this.$toastr('success', "Cadastro ativado com sucesso.");
              }
            }else{
              // console.log(res.data.error)
              this.$toastr('error',"Ocorreu um erro na operação, por favor tente novamente.")
            }
          }, () =>{
            // console.log(err);
            this.$toastr('error',"Ocorreu um erro na operação, por favor tente novamente..")
          })				
			}
      
       // console.log('ref',this.$refs);
       // nextTick executa após o DOM se montado, então nesse momento o objeto login existe
       this.$nextTick(() =>  this.$refs.email.focus() );
    },
    validations:{
      email:{
        required      
      },
      password:{
        required
      }
    },
    // beforeCreate() {
    //     //css especifica para tela de login
    //     //mudando na tag body
    //     document.body.className = 'gray-bg';
    // }
}
</script>

<style>
    .failedLogin{
        color: red;
    }
</style>